/**
 * Runtime configuration for the generated notifications client (hey-api fetch).
 *
 * Import SDK functions from this module, never from connectors/notifications
 * directly: importing here guarantees the client is configured (base URL, auth
 * token, 401 logout, error normalization) before the first call. The shared
 * cross-connector wiring lives in service/connectorRuntime.
 */
import { client } from 'connectors/notifications/client.gen';
import {
  connectorAuth,
  createUnauthorizedInterceptor,
  normalizeFastApiError,
} from 'service/connectorRuntime';

client.setConfig({
  baseUrl: process.env.NEXT_PUBLIC_NOTIFICATIONS_API_ENDPOINT || '/notifications',
  auth: connectorAuth,
});

client.interceptors.error.use(normalizeFastApiError);
client.interceptors.response.use(createUnauthorizedInterceptor('Notifications API'));

export * from 'connectors/notifications/sdk.gen';
